<!-- begin #sidebar -->
<div id="sidebar" class="sidebar d-print-none">
  <!-- begin sidebar scrollbar -->
  <div class="slimScrollDiv">
    <div
      data-scrollbar="true"
      data-height="100%"
      data-init="true"
      style="overflow: hidden; width: auto; height: 100%"
    >
      <!-- begin sidebar user -->
      <ul class="nav active">
        <li *ngIf="!!user" class="nav-profile">
          <div class="cover with-shadow imgsidebarlogin"></div>
          <div class="image">
            <a href="javascript:void(0);">
              <img class="avataradmin" [src]="user.avatar_url" />
            </a>
          </div>
          <div class="info">{{ user.name }}</div>
        </li>
      </ul>
      <!-- end sidebar user -->
      <a class="ajaxlink" href="" style="display: none"></a>
      <!-- begin sidebar nav -->
      <ul class="nav">
        <li class="nav-header">Menú</li>
        <li
          *ngFor="let item of menus"
          class="menu {{ !!item.has_sub ? 'has-sub' : '' }}"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a
            href="javascript:void();"
            #menu
            (click)="clickMenu(menu)"
            [routerLink]="item.url"
          >
            <b *ngIf="!!item.has_sub" class="caret pull-right"></b>
            <i class="{{ item.icon }}"></i>
            <span
              ><b>{{ item.title }}</b></span
            >
          </a>
          <ul *ngIf="!!item.has_sub" class="sub-menu">
            <li
              *ngFor="let sub_item of item.children"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <a href="javascript:void(0);" [routerLink]="sub_item.url">{{
                sub_item.title
              }}</a>
            </li>
          </ul>
        </li>

        <!-- begin sidebar minify button -->
        <li>
          <a
            href="javascript:void(0);"
            class="sidebar-minify-btn"
            data-click="sidebar-minify"
            ><i class="fas fa-angle-double-left"></i
          ></a>
        </li>

        <!-- <li>
          <a href="javascript:void(0)">
            <span>
              <b>{{ _version.full_version }}</b>
            </span>
          </a>
        </li> -->
        <!-- end sidebar minify button -->
      </ul>
      <!-- end sidebar nav -->
    </div>
    <div class="slimScrollBar"></div>
    <div class="slimScrollRail"></div>
  </div>
  <!-- end sidebar scrollbar -->
</div>
<div class="sidebar-bg d-print-none"></div>
<!-- end #sidebar -->
